export default [
  {
    field: 'loanReferenceId',
    method: 'isEmpty',
    validWhen: false,
    message: 'Reference ID is required. Please contact your lender for more information.',
  },
  {
    field: 'firstName',
    method: 'isEmpty',
    validWhen: false,
    message: 'First name is required.',
  },
  {
    field: 'lastName',
    method: 'isEmpty',
    validWhen: false,
    message: 'Last name is required.',
  },
  {
    field: 'phone',
    method: 'isMobilePhone',
    options: ['en-US'],
    validWhen: true,
    message: 'Phone number must be in format ###-###-####',
  },
  {
    field: 'email',
    method: 'isEmail',
    validWhen: true,
    message: 'Email must be a valid email address.',
  },
];
